import { Veranstaltung } from 'fobclient/lib/entity'
import AbstractPerson from './AbstractPerson'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Veranstaltung')

export default {
  label: 'Veranstaltung',
  route: 'veranstaltung',
  className: 'veranstaltung',
  class: Veranstaltung,
  fields: [
    Fields.organisationseinheit,
    Fields.relevantFuerWeitere,
    Fields.weitereOrganisationseinheiten,
    Fields.String('name'),
    Fields.String('veranstaltungsTyp'),
    Fields.Date('veranstaltungStart'),
    Fields.Date('veranstaltungEnde'),
    Fields.MultiReference(
      'veranstalter',
      'user',
      AbstractPerson
    ),
    Fields.URL('externeWebsite'),
    {
      label: 'Veranstaltung.form.beschreibungDE',
      field: 'beschreibungDE',
      type: 'html-text',
      render: 'html',
      maxLength: 6000
    },
    {
      label: 'Veranstaltung.form.beschreibungEN',
      field: 'beschreibungEN',
      type: 'html-text',
      render: 'html',
      maxLength: 6000
    },
    Fields.Boolean('virtuell'),
    {
      label: 'Veranstaltung.form.stadt',
      field: 'stadt',
      type: 'string',
      table: true,
      view (data) {
        return !data.virtuell
      }
    },
    {
      ...Fields.PrefetchedSingleReference(
        'land',
        'land',
        'globe'
      ),
      preselect: (land) => land.nameDE === 'Deutschland',
      prefilter: (land) => land.alpha2code !== 'EP',
      orderBy: 'nameDE',
      view (data) {
        return !data.virtuell
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Veranstaltung.js